import { Injectable, signal, WritableSignal } from '@angular/core';

import { PopoverComponent } from '@molecules/popover/popover.component';

@Injectable({
  providedIn: 'root',
})
export class PopoverService {
  public activeId: WritableSignal<string | null> = signal(null);
  private popoverComponents: PopoverComponent[] = [];

  registerPopover(component: PopoverComponent): void {
    this.popoverComponents.push(component);
  }

  unregisterPopover(id: string): void {
    this.popoverComponents = this.popoverComponents.filter((component) => component.id !== id);
  }

  getPopoverById(id: string): PopoverComponent | undefined {
    return this.popoverComponents.find((component) => component.id === id);
  }

  openPopover(data: { id: string; width?: number; active: boolean }): void {
    const popover = this.getPopoverById(data.id);
    if (popover) {
      popover.toggle(data.active);
      if (data.width) popover.width = data.width;
      if (data.active) {
        this.activeId.set(data.id);
        popover.setDirection();
        popover.setPosition();
      } else {
        this.activeId.set(null);
      }
    }
  }

  open(id: string, width?: number): void {
    this.openPopover({ id, width, active: true });
  }

  toggle(id: string, width?: number): void {
    const popover = this.getPopoverById(id);
    const active = popover ? !popover.open : false;
    this.openPopover({ id, width, active });
  }

  close(): void {
    this.popoverComponents.forEach((component) => {
      component.toggle(false);
      this.activeId.set(null);
    });
  }
}
